import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { SeriousCase } from "../_types/serious-case";

@Injectable({
    providedIn: 'root',
})
export class SeriousCasesService extends Service<SeriousCase> {
    public override type = 'caseserious';
    public override url = 'attendance/caseserious';
}
